import React from "react";
import { renderStandardInput } from "./StandardInputRenderer";
import { createSerialKey } from "../../utils/formHelpers";

/**
 * Classic form representation for form elements
 */
const ClassicFormRepresentation = ({ items, step, stepIndex, itemIndex }) => {
	return (
		<>
			{items.map((item, idx) => {
				// Generate unique key using serial key + suffix
				const key = `${createSerialKey(step, item.label, idx)}-classic`;
				
				return renderStandardInput(item, step, idx, { 
					wrapperClassName: "mb-3",
					key 
				});
			})}
		</>
	);
};

export default ClassicFormRepresentation;
